<template>
  <div class="text botter-conversation botter-hero">
    <div class="d-flex align-end " :class="getAlignment()">
      <user-chat-image :sender="con.sender" v-if="con.sender.sender_type === 'BOT'"/>
      <div class="full-width">
        <div  class="botter-text" :class="getColor()" v-if="con.payload">
          <p v-html="common.formatText(con.payload)" :class="common.getTextAlignment(con.payload)">
          </p>
        </div>
      </div>
    </div>
    <div class="botter-buttons-list">
      <div class="d-inline-block" v-for="(btn,index) in con.actions" :key="index">
        <a  v-if="btn.type === 'call'">
          <b-btn>
            {{btn.title}}
          </b-btn>
        </a>
        <a  target="_blank" v-if="btn.type === 'openUrl'">
          <b-btn>
            {{btn.title}}
          </b-btn>
        </a>
        <div >
          <b-btn v-if="btn.type === 'postBack'">
            {{btn.title}}
          </b-btn>
        </div>
      </div>
    </div>
    <div class="chat-date d-flex" :class="getAlignment()">{{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('MMMM Do YYYY')}} {{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('h:mm a')}}</div>
  </div>
</template>

<script>
  import userChatImage from "./common/userChatImage";
  import common from "../../../../utils/common";
  export default {
    name: "textData",
    components: {
      userChatImage
    },
    props: {
      con: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      index: {
        type: Number,
        default: ()=> {
          return 0
        }
      }
    },
    data() {
      return {
        common
      }
    },
    methods: {
      getAlignment() {
        if (this.con.type==='user') {
          return 'justify-end'
        } else if(this.con.type==='bot') {
          return 'justify-start'
        }
      },
      getColor() {
        if (this.con.type==='user') {
          return 'botter-user-text'
        } else if(this.con.type==='bot') {
          return 'botter-bot-text'
        }
        return 'botter-bot-text'
      },
      postBack(data) {
        this.$store.dispatch('pushMessage', {
          slug: 'text',
          payload: data.title,
          type: 'user',
          lastMessageGroup: true
        })
        this.$emit('postBack',data)
      }
    },
    computed: {

    }
  }
</script>

<style lang="scss">
  .botter-buttons-list {
  }
  .botter-buttons-list > div {
    margin-right: 10px;
    margin-top: 10px;
  }
</style>
